var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const SIGNER_SERVER_URL = "https://signer-server.plugwallet.ooo";
const requestCall = (args, resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(`${SIGNER_SERVER_URL}/call`, {
        method: "POST",
        body: JSON.stringify(args),
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
    });
    const body = yield response.json();
    if ("result" in body)
        return resolve(body.result);
    return reject(body.error);
});
const requestQuery = (args, resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(`${SIGNER_SERVER_URL}/query`, {
        method: "POST",
        body: JSON.stringify(args),
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
    });
    const body = yield response.json();
    if ("result" in body)
        return resolve(body.result);
    return reject(body.error);
});
const requestReadState = (args, resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(`${SIGNER_SERVER_URL}/readState`, {
        method: "POST",
        body: JSON.stringify(args),
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
    });
    const body = yield response.json();
    if ("result" in body)
        return resolve(body.result);
    return reject(body.error);
});
export default {
    requestCall,
    requestQuery,
    requestReadState,
};
